import { render, staticRenderFns } from "./viewEditDetail.vue?vue&type=template&id=bf248af0&scoped=true&"
import script from "./viewEditDetail.vue?vue&type=script&lang=js&"
export * from "./viewEditDetail.vue?vue&type=script&lang=js&"
import style0 from "./viewEditDetail.vue?vue&type=style&index=0&id=bf248af0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf248af0",
  null
  
)

export default component.exports